/**
 * Segments.
 */

const segments = document.querySelectorAll('[role="tab"]');
const segmentsList = document.querySelector('[role="tablist"]');

const changeSegments = e => {
  const { target } = e;
  const parent = target.parentNode;
  const grandparent = parent.parentNode;

  if (target.classList.contains('active')) {
    return;
  }

  target.classList.add('active');

  parent.querySelectorAll('[aria-selected="true"]').forEach(t => {
    t.classList.remove('active');
    t.setAttribute('aria-selected', 'false');
  });

  target.setAttribute('aria-selected', true);

  grandparent.querySelectorAll('[role="tabpanel"]').forEach(p => {
    p.setAttribute('hidden', 'true');
  });

  const selected = grandparent.parentNode.querySelector(`#${target.getAttribute('aria-controls')}`);
  if (selected !== null) {
    selected.removeAttribute('hidden');
  }
};

if (typeof segments !== 'undefined' && segments.length > 0) {
  segments.forEach(tab => {
    tab.addEventListener('click', changeSegments);
  });

  let tabFocus = 0;

  segmentsList.addEventListener('keydown', e => {
    if (e.keyCode === 39 || e.keyCode === 37) {
      segments[tabFocus].setAttribute('tabindex', '-1');
      if (e.keyCode === 39) {
        tabFocus += 1;
        if (tabFocus >= segments.length) {
          tabFocus = 0;
        }
      } else if (e.keyCode === 37) {
        tabFocus -= 1;
        if (tabFocus < 0) {
          tabFocus = segments.length - 1;
        }
      }

      segments[tabFocus].setAttribute('tabindex', '0');
      segments[tabFocus].focus();
    }
  });
}
